let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c3CmY")).then(() => parcelRequire('cJzMU'));